import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_DEVICE_SLAVES_LIST,
  GET_DEVICE_SLAVES_LIST_SUCCESS,
  GET_DEVICE_SLAVES_LIST_ERROR,
  GET_DEVICE_SLAVE,
  GET_DEVICE_SLAVE_SUCCESS,
  GET_DEVICE_SLAVE_ERROR,
  DELETE_DEVICE_SLAVE,
  DELETE_DEVICE_SLAVE_SUCCESS,
  DELETE_DEVICE_SLAVE_ERROR,
  UPDATE_DEVICE_SLAVE,
  UPDATE_DEVICE_SLAVE_SUCCESS,
  UPDATE_DEVICE_SLAVE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/deviceSlave';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.deviceSlave;
const deviceSlave = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullDeviceSlave') {
        return {
          ...state,
          current: { ...initialSettings.current },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentDeviceSlave':
          key = 'current';
          break;
        case 'updateDeviceSlave':
          key = 'update';
          break;
        case 'deleteDeviceSlave':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_DEVICE_SLAVES_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_DEVICE_SLAVES_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEVICE_SLAVES_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_DEVICE_SLAVE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null,
        },
      };
    case GET_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // DELETE
    case DELETE_DEVICE_SLAVE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // UPDATE
    case UPDATE_DEVICE_SLAVE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default deviceSlave;



// WEBPACK FOOTER //
// ./reducers/device/deviceSlave.js